import { type PriceData } from "~/domains/pricing/types/PriceData";
import * as PriceUtils from "~/utils/PriceUtils";
import classNames from "classnames";
import { type FC, memo, type ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface OrderTotalsProps {
  totalValue: PriceData | null;
  className?: string;
}

const BigText = ({ children }: { children?: ReactNode }) => <span className={"title-large f-bold"}>{children}</span>;

const Row: FC<{ className?: string; children?: ReactNode }> = ({ children, className }) => {
  const cls = classNames("d-flex flex-justify-between", className);
  return <div className={cls}>{children}</div>;
};

const QuoteOrderTotals: FC<OrderTotalsProps> = ({ totalValue, className }) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <Row>
        <BigText>{t("activeQuotePage.totalTargetPrice")}</BigText>
        <BigText>{totalValue ? PriceUtils.text(totalValue) : "..."}</BigText>
      </Row>
    </div>
  );
};

export default memo(QuoteOrderTotals);
